import React from 'react';
import { bool, func, string } from 'prop-types';
import AUIButton from '@ancert/aui-button';
import AUIIcon from '@ancert/aui-icon';
import { ESTADOS_DENUNCIA } from '../../lib/denuncia.enum';

const ConsultarDenunciaHeader = ({ status, canGoBack, title, date, onClickBack }) => (
  <div className="c-sii-consultar-denuncia-header">
    <h1 className="c-sii-consultar-denuncia-header__title">
      {title}
      {status && (
        <div className="c-sii-consultar-denuncia-header__status">
          {date}
          <AUIIcon color={ESTADOS_DENUNCIA[status].color} icon="status" size="lg" />
          {ESTADOS_DENUNCIA[status].desc}
        </div>
      )}
    </h1>
    {canGoBack && (
      <AUIButton
        iconPos="left"
        icon="arrowLeft"
        label="Volver al listado"
        mode="outline"
        size="lg"
        onClick={onClickBack}
      />
    )}
  </div>
);
ConsultarDenunciaHeader.propTypes = {
  status: string,
  title: string,
  date: '',
  canGoBack: bool,
  onClickBack: func,
};
ConsultarDenunciaHeader.defaultProps = {
  status: '',
  title: '',
  date: '',
  canGoBack: false,
  onClickBack: () => null,
};

export default ConsultarDenunciaHeader;
